import { Route } from "@dashboard/components/Router";
import { sectionNames } from "@dashboard/intl";
import { useIntl } from "react-intl";
import { Switch } from "react-router-dom";

import { WindowTitle } from "../components/WindowTitle";
import { exportOverviewPath } from "./urls";
import { ExportOverview } from "./views/ExportOverview/ExportOverview";

const ExportSection = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.exports)} />
      <Switch>
        <Route exact path={exportOverviewPath} component={ExportOverview} />
      </Switch>
    </>
  );
};

export default ExportSection;
